import type { FaireProductEntity } from "../../entity_types/product";

export const p_nrk8wr7wdq: FaireProductEntity = {
  token: "p_nrk8wr7wdq",
  type: "product",
  name: "B2B-Exclusive Half Sleeve Shawl Sheath High Stretch Round Neck Knee Length Wedding Guest Dresses",
  brandToken: "b_9x9dfusr4t",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f55366a4079d941c6ea79482b8df3f425dd827902f50ac860461ffa4a6391911.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a19c6832793a197732bfe2223c7dcdb339ce98d70961b9168f0eb8d3cdf7c55.jpeg",
    "https://cdn.faire.com/fastly/2a8a4b44c5100bd62d4d76b254462fd45ac4e503e1a760071b9f8d7f1fdf6a5b.jpeg",
    "https://cdn.faire.com/fastly/223a5ad8629da1eddea8ef474d8d4cbc4b056d329333154715718a6e9eb5c381.jpeg",
    "https://cdn.faire.com/fastly/c13865bdceebebb07fe79906cb6fa96a358fde43d9f39046ff051b3d6efaa4b5.jpeg",
    "https://cdn.faire.com/fastly/9c87d05ccb9a18f849b7fb9eb37963c5f635fcd4f72c077aff633db753a16f32.jpeg",
    "https://cdn.faire.com/fastly/9da7f1fdeb768fb42ace8d4be71a59227169042e7e21d0d81fba4974fcd61077.jpeg",
    "https://cdn.faire.com/fastly/9422fcfa7b53e41c73248c0cc27665b9022e322ac7b0c2c429cd737a1e3f8a37.jpeg",
    "https://cdn.faire.com/fastly/3d94ddbd07601bd8974c0e1bb73632a004d158233a71015ac09f37aa2a3bd26a.jpeg",
    "https://cdn.faire.com/fastly/87c93c072abb17d8821e67549def50bbbed6bab9aa459e5327d90024a4e2dd38.jpeg",
    "https://cdn.faire.com/fastly/49e1b80e3f3015c7b763a6e548d4139923402634ee49646dddf048a82c1d5e66.jpeg",
    "https://cdn.faire.com/fastly/fa65dda2ef4ad5a6659b3164d736212da9e71af2c610434e94340304c713bb24.jpeg",
    "https://cdn.faire.com/fastly/5ed1a286a3a4af4e8743bfa30eb2fa8f2c317dfff6b29c34c82541f2bb8430ab.jpeg",
    "https://cdn.faire.com/fastly/2041dbd883bde7549c33e4bbd6ff4ce053315b89c1206e2ded4e3b04255bcd72.jpeg",
    "https://cdn.faire.com/fastly/7ec898f3d48923eecb7aab577596db8a33cc09d86eee79a34522c1add0e3b716.jpeg",
    "https://cdn.faire.com/fastly/5f7469165b00042f20e88a7fe38ce675acef2773dc87b1721711f1c04f59c0c7.jpeg",
    "https://cdn.faire.com/fastly/da6f5488c6325014e47859aaf44000759d554e58628373346049d6e689e359dd.jpeg",
    "https://cdn.faire.com/fastly/2f9bd35a78f47188e05908d0c2470338fe10a47192f3fa4e36e02542dc3f63cb.jpeg",
    "https://cdn.faire.com/fastly/29086c36fd43cf15aecb7dfb19facdaf5dddd9ceac230ad13765431a8a3fb5a4.jpeg",
    "https://cdn.faire.com/fastly/2295ab60561b2a5fa5f5373c9913713967febc77891bff910d2af6c6818b9a01.jpeg",
    "https://cdn.faire.com/fastly/4b1e40f6b9b5bec85108f77fda965e736915b5115a246304d94690d585f440fb.jpeg",
  ],
  priceDollars: 60.96,
  description:
    "PRODUCT HIGHLIGHTS\n\nTimeless Elegance for Every Special Occasion\n\n\n\nClassic Round Neck Design: A sophisticated neckline that flatters all body types, perfect for formal events.\n\n\nHigh Stretch Knit Fabric: Offers exceptional comfort and flexibility, allowing for ease of movement while maintaining a sleek silhouette.\n\n\nSheath Silhouette: Tailored fit that accentuates curves, making it an ideal choice for evening parties and weddings.\n\n\nElegant Shawl Detail: Adds a touch of refinement and versatility, allowing for stylish layering options.\n\n\nFit: Please refer to size chart.\n\n\nLength: Knee-length.\n\n\nSleeve Style: Half sleeves.\n\n\nClosure: Back zipper.\n\n\nUndergarments: It is not padded, with lining.\n\n\nFabric:The garment comprises knit.\n\n\nStretch: Fabric is high stretch.\n\n",
  tags: [],
  msrpDollars: 121.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:10.776Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
